import {
    BoxedRow,
    IconChevronLeftRegular,
    IconCloudRegular,
    IconDataBonusRegular,
    IconDeviceSignalRegular,
    IconEuroSymbolCircleRegular,
    NavigationBar,
    Row,
    RowList,
    Tag,
    Text2,
    Text6,
    ThemeVariant,
    skinVars,
} from '@telefonica/mistica';
import './index.scss';
import '../../translations/i18n';
import BillingCycle from '../BillingCycle';
import NeedMoreGigs from '../NeedMoreGigs';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import MobileSectionBoxed from '../MobileSectionBoxed';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import navigateParams from '../../utils/navigation/navigateParams';
import { getBonusOffering } from '../../services/ProductService';
import { getFormatDate, getStringCycle } from '../../utils/dataTransformation/dateConversions';
import { checkIfMainMobile, getConsumptionById } from '../../utils/dataTransformation/productConsumption';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../../utils/store/features/user';
import useUserlight from '../../utils/hooks/useUserLight';
import { TrackingEvents } from '../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../utils/navigation/controlDevices';
import { managementEnvironment } from '../../utils/dataTransformation/environments';
import { WarningLine } from '../WarningEsim';
import { InfoSIM } from '../../models/ConfigureLine';
import { getSIMSInfos } from '../../services/ConfigureLineService';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useConfigureLineContext } from '../../utils/store/context/configure-line-context/ConfigureLineContext';
import { formatMobileNumber } from '../../utils/dataTransformation/unitsConversion';
import BreadCrumbsWrapper from '../BreadcrumbsWrapper';
import { useMobileLinesContext } from '../../utils/store/context/mobile-lines-context/MobileLinesContext';
import useConfigureLine from '../../pages/ConfigureLine/utils/hooks';
import useSimsInfos from '../../utils/hooks/useSimsInfos';

export interface MobileSectionsData {
    mobileNumber: any;
    data: any;
    navigate: Function;
    typeClicked: any;
}

export const MobileConsumption: React.FC<MobileSectionsData> = ({ mobileNumber, navigate }: MobileSectionsData) => {
    const { t } = useTranslation();
    const isLight = useUserlight();
    const queryClient = useQueryClient();
    const currentPath = JSON.parse(sessionStorage.getItem('breadcrumb')!);
    const dispatch = useDispatch();
    const [params] = useSearchParams();
    const { state } = useLocation();
    const [searchParams] = useSearchParams();
    const navigateLoc = useNavigate();
    const { setLineActive, blocked } = useConfigureLineContext();
    const { checkRestrictions } = useConfigureLine();
    const { showOptionDataSharing } = useMobileLinesContext();
    const { trackingUserInteraction } = new TrackingEvents();
    const [hasOffering, setHasOffering] = useState(false);
    const [extraBonus, setExtaBonus] = useState(false);
    const [dataSims, setDataSims] = useState<InfoSIM[]>([]);
    const { simsInfosRequest } = useSimsInfos();

    const URL_02CLOUD = process.env.REACT_APP_WEBVIEW_O2CLOUD as string;
    const O2Cloud_home = managementEnvironment().REACT_APP_WEBVIEW_O2CLOUD_HOME_ENABLED;
    const pendingEsim: InfoSIM[] = dataSims?.filter(
        (pending) => pending.number === mobileNumber.replaceAll(/\s/g, '') && pending.pending,
    )!;
    const _storage = window.localStorage.getItem('storages');
    let storageJson = getConsumptionById(JSON.parse(_storage ?? ''), params.get('productPsId')!);
    localStorage.setItem('storage', JSON.stringify(storageJson));
    const cicloInfo = getStringCycle(storageJson?.cycleStarts, storageJson?.cycleEnds);

    useEffect(() => {
        simsInfosRequest(setDataSims);
    }, []);

    useEffect(() => {
        checkRestrictions(storageJson.productId);
    }, []);

    useEffect(() => {
        queryClient.invalidateQueries({ queryKey: ['sims-info'] });
        setExtaBonus(storageJson?.dataBonus);
        getBonusOffering(searchParams.get('productId') || '' || storageJson?.productId).then(async (results: any) => {
            setHasOffering(results.data.length > 0);
        });
    }, []);

    const sendToNative = (url: string, type: string, title: string) => {
        const productPsId: any = searchParams.get('productPsId');
        if (title === t('returnExtraExpenseDetail')) {
            const number = window.localStorage.getItem('mc-number');
            const isOtherLine = number !== storageJson.number;
            if (isLight && isOtherLine) {
                dispatch(showSnackbar());
            } else {
                const queryParams = { productPsId };
                if (navigateParams(type, url, queryParams, storageJson, title)) {
                    sessionStorage.setItem(
                        'breadcrumb',
                        JSON.stringify([{ title: state ? state : currentPath[0]?.title, url: window.location.href }]),
                    );
                    navigateLoc(url + '?productPsId=' + productPsId, { state: mobileNumber });
                }
            }
        } else if (title === t('lineManagement')) {
            const productId: any = storageJson.productId;
            const queryParams = {
                productId,
                multisim: storageJson.multiSim,
                phone: mobileNumber.replaceAll(/\s/g, ''),
            };
            sessionStorage.setItem('pathOrigin', window.location.href.replace(window.location.origin, ''));
            if (navigateParams(type, url, queryParams, storageJson, title)) {
                sessionStorage.setItem(
                    'breadcrumb',
                    JSON.stringify([{ title: state ? state : currentPath[0]?.title, url: window.location.href }]),
                );
                setLineActive(productId);
                navigateLoc(url, {
                    state: {
                        phone: mobileNumber.replaceAll(/\s/g, ''),
                        productId,
                    },
                });
            }
        } else if (title === t('o2CloudTitle')) {
            if (navigateParams(type, url, {}, {}, title, '', false)) {
                window.location.href = `${url}`;
            }
        } else if (title === 'O2CloudApp') {
            if (navigateParams(type, url, {}, {}, title, '', false)) {
                window.open(url, '_blank');
            }
        } else {
            try {
                let operation = storageJson.datasharing ? 'desactivate' : 'activate';
                const queryParams = {
                    productId: storageJson.productId,
                    status: storageJson.datasharing,
                    operation,
                };
                const storage = { ...storageJson, cicle: cicloInfo };
                if (navigateParams(type, url, queryParams, storage, title)) {
                    window.localStorage.setItem('breadcrumb', JSON.stringify([{ title, url: window.location.href }]));
                    navigateLoc(
                        `${url}?status=${storageJson.datasharing}&operation=${operation}&productId=${storageJson.productId}`,
                        {
                            state: { title, mobileNumber },
                        },
                    );
                }
            } catch (error) {
                console.error(error);
            }
        }
    };
    return (
        <div className='MobileConsumption'>
            <div className='MobileConsumption__mobile' style={{ background: skinVars.colors.backgroundBrand }}>
                {!(isWebviewIOS || isWebviewAndroid) && (
                    <>
                        <div className='MobileConsumption__mobile-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigateLoc('/home');
                                }}
                                title={t('principalLine')}
                            />
                        </div>
                        <div className='MobileConsumption__mobile-return'>
                            <div
                                className='MobileConsumption__mobile-return-cursor'
                                onClick={() => {
                                    navigateLoc('/home');
                                }}
                            >
                                <div className='MobileConsumption__mobile-return-icon'>
                                    <IconChevronLeftRegular color={skinVars.colors.appBarBackground} size={20} />
                                </div>
                                <Text2 medium color={skinVars.colors.appBarBackground}>
                                    {t('returnResponsive')}
                                </Text2>
                            </div>
                        </div>
                    </>
                )}
                <div className='MobileConsumption__mobile-breadcrumbs'>
                    <ThemeVariant isInverse>
                        <BreadCrumbsWrapper
                            title={currentPath ? currentPath[currentPath?.length - 1].title : ''}
                            breadcrumbs={[{ url: '/home', title: 'Inicio' }]}
                        />
                    </ThemeVariant>
                </div>
                <div className='MobileConsumption__mobile-number'>
                    <Text6 color={skinVars.colors.textNavigationBarPrimary}>
                        {formatMobileNumber(storageJson?.number)}
                    </Text6>
                </div>
            </div>
            <div className='MobileConsumption__warningEsim'>
                {
                    <WarningLine
                        warningsInfo={pendingEsim}
                        blockedLine={{
                            blocked: blocked,
                            number: storageJson?.number,
                            productId: storageJson?.productId,
                        }}
                    />
                }
            </div>
            <div className='MobileConsumption__content'>
                <div className='MobileConsumption__content__consumptions'>
                    <div className='MobileConsumption__content__consumptions-cards'>
                        <MobileSectionBoxed
                            title={t('mobileData')}
                            data={storageJson}
                            navigate={navigate}
                            typeClicked={state}
                        ></MobileSectionBoxed>
                    </div>
                    <div className='MobileConsumption__content__consumptions__rows'>
                        <RowList>
                            {storageJson?.cloudOffering && O2Cloud_home && (
                                <Row
                                    asset={<IconCloudRegular />}
                                    headline={
                                        <Tag type={storageJson?.cloudHired ? 'success' : 'warning'}>
                                            {storageJson?.cloudHired ? t('o2TagActive') : t('o2TagDisable')}
                                        </Tag>
                                    }
                                    title={t('o2CloudTitle')}
                                    badge={storageJson?.cloudHired ? false : true}
                                    onPress={() => {
                                        !storageJson?.cloudHired
                                            ? sendToNative(URL_02CLOUD, 'modeBrowser', t('o2CloudTitle'))
                                            : sendToNative(
                                                  'https://cloud.o2online.es/app/',
                                                  'modeExternal',
                                                  'O2CloudApp',
                                              );
                                    }}
                                ></Row>
                            )}
                            <Row
                                asset={<IconEuroSymbolCircleRegular />}
                                title={t('extraExpense')}
                                badge={storageJson?.extraSum > 0 ? true : false}
                                onPress={() => {
                                    sendToNative(
                                        '/mobile/extra-expense',
                                        'modeFlow-backgroundBlue',
                                        t('returnExtraExpenseDetail'),
                                    );
                                }}
                            ></Row>
                            {showOptionDataSharing &&
                                checkIfMainMobile(JSON.parse(_storage ?? ''), searchParams.get('productPsId')!) && (
                                    <Row
                                        asset={<IconDeviceSignalRegular />}
                                        headline={
                                            <Tag type={storageJson?.datasharing ? 'success' : 'inactive'}>
                                                {storageJson?.datasharing ? t('activated') : t('disabled')}
                                            </Tag>
                                        }
                                        title={t('sharedData')}
                                        onPress={() => {
                                            trackingUserInteraction('shared_data_tapped');
                                            sendToNative(
                                                '/enable-shared-data',
                                                'modeModal-backgroundBlue',
                                                t('sharedData'),
                                            );
                                        }}
                                    ></Row>
                                )}
                            {extraBonus && (
                                <Row
                                    asset={<IconDataBonusRegular />}
                                    title={t('checkExtraBonus')}
                                    onPress={() => {
                                        trackingUserInteraction('detail_bonus_extra_tapped');
                                        sendToNative(
                                            '/bonus-extra-details',
                                            'modeFlow-backgroundBlue',
                                            t('returnBonusExtra'),
                                        );
                                    }}
                                ></Row>
                            )}
                        </RowList>
                    </div>

                    <div className='MobileConsumption__content__consumptions-billingCycle'>
                        <BillingCycle
                            BillingCycle={`${getFormatDate(storageJson?.cycleStarts, 'DD/MM')} - ${getFormatDate(
                                storageJson?.cycleEnds,
                                'DD/MM',
                            )} `}
                            closing={`${storageJson?.cycleEndInDays} ` + t('day')}
                        ></BillingCycle>
                    </div>
                </div>
                <div className='MobileConsumption__content__cardInfo'>
                    {hasOffering && !blocked && (
                        <div className='MobileConsumption__content__cardInfo-needMoreGb'>
                            <NeedMoreGigs productId={storageJson?.productId}></NeedMoreGigs>
                        </div>
                    )}
                    <div className='MobileConsumption__content__cardInfo-lineServices'>
                        <BoxedRow
                            title={t('lineManagement')}
                            description={t('lineConfigurationDescription')}
                            onPress={() => {
                                sendToNative('/configure-line', 'modeFlow-backgroundBlue', t('lineManagement'));
                            }}
                        ></BoxedRow>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MobileConsumption;
